import React from "react";
import { FieldRenderProps } from "react-final-form";

import { TextFieldProps } from "@material-ui/core/TextField";

import withFieldControl from "../FieldControl";

import { TextField } from "./styles";

type Props = {
  required?: boolean;
  onlyPositiveNumbers?: boolean;
} & TextFieldProps;

const DECIMAL_NUMBER_PATTERN_DEFAULT = /^[-]?([0-9]+([.][0-9]*)?|[.][0-9]+)?$/;
const DECIMAL_POSITIVE_NUMBER_PATTERN = /^([0-9]+([.][0-9]*)?|[.][0-9]+)?$/;

const DecimalNumberFieldControl = ({
  autoFocus,
  autoComplete,
  input,
  label,
  required,
  type,
  error,
  meta,
  onlyPositiveNumbers,
  ...props
}: FieldRenderProps<any> & Props) => {
  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const pattern = !onlyPositiveNumbers
      ? DECIMAL_NUMBER_PATTERN_DEFAULT
      : DECIMAL_POSITIVE_NUMBER_PATTERN;
    const value = event.target.value;

    if (pattern.test(value)) {
      input.onChange(event);
    }
  };

  return (
    <TextField
      {...{ ...input, onChange }}
      type={type}
      label={label}
      helperText={(meta.touched && meta.error) || error}
      error={Boolean((meta.touched && meta.error) || error)}
      autoFocus={autoFocus}
      autoComplete={autoComplete}
      required={required}
      {...props}
    />
  );
};

export default withFieldControl(DecimalNumberFieldControl);
